var preDeliveryWithPositiveBalance = function (isPredelivery, currentBalance) { return isPredelivery && currentBalance > 0; };
export default preDeliveryWithPositiveBalance;
//# sourceMappingURL=preDeliveryWithPositiveBalance.js.map